<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>{{ state == 'archived' ? '已归档质保管理' : '质保管理' }}</h4>
      </div>
      <div class="c-flex">
        <el-date-picker
          class="c-m-r-15"
          v-model="searchDateValue"
          type="datetimerange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          @change="getData()"
        ></el-date-picker>
        <el-input
          placeholder="请输入业主名称或业主手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          v-if="osg.has('Warrantys,export')"
          @click="
            osg.doExport(
              {
                'regex:ownerName|string#or': searchValue,
                'regex:ownerPhone|string#or': searchValue,
                'is:docId|string#or': searchValue,
                'lte:createTime|date#and': searchDateValue ? searchDateValue[1] : '',
                'gte:createTime|date#and': searchDateValue ? searchDateValue[0] : '',
                'in:state|integer#and': state == 'archived' ? -1 : 1,
                title: '质保管理',
                beanName: 'warranty'
              },
              {
                preset: '0'
              }
            )
          "
          class="c-m-l-10"
        >
          导出
        </el-button>
        <el-button
          v-if="osg.has('Warrantys,expurgate')"
          type="primary"
          class="c-m-l-10"
          @click="batchExpurgate"
        >
          归档
        </el-button>
        <el-button
          type="primary"
          v-if="osg.has('Warrantys,offlineExport')"
          @click="
            osg.doExport(
              {
                'regex:ownerName|string#or': searchValue,
                'regex:ownerPhone|string#or': searchValue,
                'is:docId|string#or': searchValue,
                'lte:createTime|date#and': searchDateValue ? searchDateValue[1] : '',
                'gte:createTime|date#and': searchDateValue ? searchDateValue[0] : '',
                'in:state|integer#and': state == 'archived' ? -1 : 1,
                title: '质保管理',
                beanName: 'warranty'
              },
              {
                preset: '0',
                url: 'excel/offlineExport.do',
                headers: { 'content-type': 'application/json;charset=utf-8' },
                noAnalysis: true
              },
              offlineExportBack
            )
          "
          class="c-m-l-10"
        >
          离线下载
        </el-button>
        <!--  Wexport('document', {
              'regex:ownerName|string#or': searchValue,
              'regex:ownerPhone|string#or': searchValue,
              'lte:createTime|date#and': searchDateValue ? searchDateValue[1] : '',
              'gte:createTime|date#and': searchDateValue ? searchDateValue[0] : ''
            })
            
             osg.doExport({
              'regex:ownerName|string#or': searchValue,
              'regex:ownerPhone|string#or': searchValue,
              'lte:createTime|date#and': searchDateValue ? searchDateValue[1] : '',
              'gte:createTime|date#and': searchDateValue ? searchDateValue[0] : '',
              title: '质保管理',
              beanName: 'warranty',
            },{
              url:'document/export2.do'
            }) -->
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table" v-if="fpi.data">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          @selection-change="selectionChange"
        >
          <!--        多选框功能：1.增加多选框的一列，需要在《el-table》标签头里面加入：@selection-change="selectionChange" ，表示点击多选框时调用的函数     -->
          <el-table-column
            v-if="osg.has('Warrantys,expurgate')"
            type="selection"
            fixed
            width="55"
          ></el-table-column>
          <el-table-column label="委托方" width="100" prop="ownerName" fixed>
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="handleRowClick(scope.row)"
                type="text"
                style="white-space: normal;line-height: 2;"
              >
                {{ scope.row.ownerName }}
              </el-button>
            </template>
          </el-table-column>
          <template v-if="tenantId == '4551453470943235290'">
            <el-table-column
              prop="ownerPhone"
              label="业主手机号"
              min-width="100px"
            ></el-table-column>
            <el-table-column prop="identity" label="证件号" min-width="150px"></el-table-column>
            <el-table-column
              prop="serviceAppointmentNum"
              label="工单编号"
              min-width="130px"
            ></el-table-column>
            <el-table-column prop="part" label="部位" show-overflow-tooltip min-width="160px">
              <template slot-scope="scope">
                {{ formatPart(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="serviceAppointmentAddress"
              label="施工地址"
              min-width="160px"
            ></el-table-column>
            <el-table-column
              prop="contactsAddress"
              label="联系地址"
              min-width="160px"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建日期"
              min-width="150px"
              :formatter="formatData"
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新时间"
              min-width="150px"
              :formatter="formatData"
            ></el-table-column>
            <el-table-column
              prop="startTime"
              label="质保生效时间"
              min-width="150px"
            ></el-table-column>
            <el-table-column
              prop="warrantyTime"
              label="质保结束时间"
              min-width="150px"
            ></el-table-column>
            <el-table-column prop="isClaim" label="是否出险" min-width="100px"></el-table-column>
            <el-table-column
              prop="guaranteeAmount"
              label="保障金额"
              min-width="100px"
            ></el-table-column>
            <el-table-column
              prop="claimAmount2"
              label="累计出险金额"
              min-width="100px"
            ></el-table-column>
            <el-table-column
              prop="claimAmountSun"
              label="剩余保障金额"
              min-width="100px"
            ></el-table-column>
            <el-table-column prop="warrantyPdf" label="PDF地址" min-width="300px">
              <template slot-scope="scope">
                <el-link
                  :href="
                    'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                      encodeURIComponent(scope.row.warrantyPdf)
                  "
                  target="_blank"
                >
                  {{ scope.row.warrantyPdf }}
                </el-link>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="guaranteedTime"
              label="保障结束时间"
              min-width="150px"
            ></el-table-column> -->
            <el-table-column prop="docId" label="客户流水号" min-width="150px"></el-table-column>
            <el-table-column prop="memo" label="备注" min-width="100px"></el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="100px"></el-table-column>
            <el-table-column
              prop="comments"
              label="归档原因"
              min-width="100px"
              v-if="state == 'archived'"
            ></el-table-column>
          </template>
          <template v-if="tenantId != '4551453470943235290'">
            <template v-for="(extFiel, index) in extFields">
              <el-table-column
                :width="extFiel.width || '180px'"
                :prop="'exts.' + extFiel.name"
                show-overflow-tooltip
                :label="extFiel.nameDisp"
                :key="index"
                v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
              >
                <template slot-scope="scope">
                  {{
                    formatterCodelabel(scope.row[extFiel.name], extFiel.valueOption, extFiel.type)
                  }}
                </template>
              </el-table-column>
            </template>
          </template>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="
              osg.has('Warrantys,archive') ||
                osg.has('Warrantys?state=archived,recover') ||
                osg.has('Warrantys,accident')
            "
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('Warrantys,accident')"
                    @click.native="doAccident(scope.row)"
                  >
                    出险
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Warrantys,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档', 1)"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Warrantys?state=archived,recover') && state == 'archived'"
                    @click.native="doArchive(scope.row, '恢复', 2)"
                  >
                    恢复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      class="accidentFormWarranty-wrapper"
      title="理赔信息"
      :visible.sync="accidentData.openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-if="accidentData.openDetail && Array.isArray(options.claimPart)"
    >
      <c-form
        :formData="accidentData.formData"
        :upload="upload"
        :fields="accidentExtFields"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
      >
        <template slot="leakagePart">
          <el-select
            v-model="accidentData.formData.exts.leakagePart"
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.claimPart.filter(item =>
                this.accidentData.claimPartScopeList.includes(item.value)
              )"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="claimPartList">
          <el-select
            v-model="accidentData.formData.exts.claimPartList"
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.claimPart.filter(item =>
                this.accidentData.claimPartScopeList.includes(item.value)
              )"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doAccidentSave">确 定</el-button>
        <el-button @click="doAccidentInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'Warrantys',
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    let that = this;
    return {
      selectedList: [],
      name: 'warranty',
      fpi: {},
      searchValue: '', //搜索文本
      searchDateValue: [], //搜索日期
      openDetail: false,
      state: '', //归档状态
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        // codecfg_part: { codeId: "part" }
      },
      tenantId: '', //租户id
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      //归档原因根据是否配置字段comments判断是否需要填写归档原因
      fillArchiveReason: false,
      //出险质保对象
      accidentData: {
        openDetail: false,
        claimPartScopeList: [], //当前质保可理赔的部位
        row: {}, //质保对象
        formData: { exts: { image1: [], image2: [], image3: [] } }
      },
      accidentExtFields: [], //出险质保字段
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.state = this.$route.query.state;
    this.tenantId = acount.tenantId;
    this.osg.getFpi();

    //请求出险质保字段
    if (this.tenantId == '4551453470943235290') {
      this.osg.getFields(
        'claims',
        () => {
          // this.accidentExtFields = this.accidentExtFields.filter(
          //   item => item.frontEndConfig.addForm
          // );
        },
        this,
        'accidentExtFields'
      );
    }

    this.getData().then(data => {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'warranty',
          _all: '1',
          'in:state|array-integer#and': '1',
          'in:extId|Array#and': data.extFields
        },
        res => {
          this.extFields = res.data;
          //归档原因根据是否配置字段comments判断是否需要填写归档原因
          this.extFields = this.extFields.filter(item => {
            // debugger;
            if (item.preset == 0 && item.name == 'comments') {
              if (this.state != 'archived') {
                this.fillArchiveReason = true;
                return false;
              }
            }
            return true;
          });
          this.options = this.options || [];

          for (var item of res.data) {
            // 解析frontEndConfig
            if (window.$this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption)
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.osg.codeoption(() => {
            this.$nextTick(() => {
              this.$refs.table.doLayout();
              this.$forceUpdate();
            });
          });
        },
        { noload: true }
      );
    });
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    test() {
      this.$prompt('开发处理！！！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.fpi.data.forEach(item => {
            this.osg.ajax(
              'document/upsertWarranty.do',
              { warranty: JSON.stringify(item) },
              res => {}
            );
          });
        })
        .catch(() => {});
    },
    formatState(row, column, cellValue, index) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatData(row, column, cellValue, index) {
      return new Date(cellValue)
        .toLocaleString('chinese', {
          hour12: false
        })
        .replace(/\//g, '-');
    },
    formatPart(row) {
      let returnArr = [];
      for (let item of this.extFields) {
        for (let key in row) {
          //查询带有part，值为-的
          if (findPart(key) && row[key] != '-') {
            if (item.name == key) {
              // return item.nameDisp + ' ' + row[key];
              returnArr.push(item.nameDisp + ' ' + row[key]);
            }
          }
        }
      }
      return returnArr.join('、');
      function findPart(text) {
        return text.indexOf('part') != -1 ? text : false;
      }
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      return new Promise(resolve => {
        var params = {
          page: this.fpi.page,
          rows: this.fpi.rows,
          'regex:ownerName|string#or': this.searchValue,
          'regex:ownerPhone|string#or': this.searchValue,
          'is:docId|string#or': this.searchValue,
          'lte:createTime|date#and': this.searchDateValue ? this.searchDateValue[1] : '',
          'gte:createTime|date#and': this.searchDateValue ? this.searchDateValue[0] : '',
          'in:state|integer#and': this.state == 'archived' ? -1 : 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        //添加过滤器参数
        if (window.$that) {
          $that.getParams(params);
        }
        this.osg.setFpi(params);
        this.osg.ajax('document/queryWarranty.do', params, res => {
          let extFields = res.data.map(item => item.extId).join();
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          resolve({ res: res, extFields: extFields });
        });
      });
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (
        (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) ||
        Array.isArray(cellValue)
      ) {
        let value = Array.isArray(cellValue) ? cellValue : cellValue.split(',');

        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    Wexport(smodule, params) {
      if (window.$that) {
        $that.getParams(params);
      }
      this.osg.ajax(
        `/${smodule}/export.do`,
        params,
        res => {
          //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');

          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        },
        {
          responseType: 'blob'
        }
      );
    },
    //导出成功回调
    offlineExportBack() {
      this.osg.alert('操作成功！正在生成文件... 点击跳转查看', () => {
        this.$router.push({ path: '/Stask' });
      });
    },
    //归档/恢复接口
    doArchive(row, msg, state) {
      if (this.fillArchiveReason && state == 1) {
        this.$prompt('请输入归档原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: null,
          inputErrorMessage: '归档原因不能为空',
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(({ value }) => {
            this.osg.ajax('document/deleteWarranty/' + row._id + '.do', { comments: value }, () => {
              this.getData();
              this.osg.toast(`已${msg}质保`);
            });
          })
          .catch(() => {});
      } else {
        this.osg.confirm(`是否确认${msg}质保？`, () => {
          this.osg.ajax('document/deleteWarranty/' + row._id + '.do', null, () => {
            this.getData();
            this.osg.toast(`已${msg}质保`);
          });
        });
      }
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      var params = this.$util.deepCopy(this.formData);
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        this.osg.ajax('basic/address/upsert.do', params, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/address/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/address/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //点击出险按钮
    doAccident(row) {
      this.doAccidentInit();
      //出险质保对象
      // accidentData: {
      //   openDetail: false,
      //   formData:{},
      //   extFields:[]
      // }
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'in:_id|string#and': row.orgId,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          if (res.data.orgList && res.data.orgList.length) {
            this.$set(this.accidentData.formData, 'claimObject', res.data.orgList[0].orgName); //赔付对象
            this.accidentData.row = row; //质保对象
            this.accidentData.openDetail = true;
            this.accidentData.claimPartScopeList = []; //当前质保可理赔的部位

            for (let key in this.accidentData.row) {
              if (key.indexOf('part') != -1 && row[key] != '-') {
                this.accidentData.claimPartScopeList.push(key.replace('part', ''));
              }
            }

            this.$set(this.accidentData.formData, 'name', this.accidentData.row.ownerName); //质保姓名
            this.$set(this.accidentData.formData, 'phone', this.accidentData.row.ownerPhone); //质保号码
            this.$set(
              this.accidentData.formData.exts,
              'constructionAddress',
              this.accidentData.row.serviceAppointmentAddress
            ); //施工地址根据质保的来
            this.$set(
              this.accidentData.formData.exts,
              'claimPartScopeList',
              this.accidentData.claimPartScopeList
            ); //质保部位的选择范围
          } else {
            this.osg.toast('所选质保的服务商不存在！！', 'warning');
          }
        },
        {
          noload: true
        }
      );
    },
    // 初始化出险质保
    doAccidentInit() {
      this.accidentData.openDetail = false;
      this.accidentData.formData = { exts: { leakagePart: [] } };
    },
    //验证手机号
    checkMobile(sMobile) {
      if (!/^1[3456789]\d{9}$/.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    myValidate() {
      //检测是否必填
      for (var extField of this.accidentExtFields) {
        if (
          extField.required == '1' &&
          (extField.type == 'file' ||
            extField.type == 'area' ||
            extField.type == 'scan' ||
            extField.type == 'addItem' ||
            extField.type == 'checkbox' ||
            extField.type == 'bizSelect')
        ) {
          if (extField.preset == 1) {
            if (!this.accidentData.formData[extField.name]) {
              this.osg.toast(extField.nameDisp + '为必填项1', 'warning');
              return;
            }

            if (this.accidentData.formData[extField.name].length == 0) {
              this.osg.toast(extField.nameDisp + '为必填项2', 'warning');
              return;
            }
          } else {
            if (!this.accidentData.formData.exts[extField.name]) {
              this.osg.toast(extField.nameDisp + '为必填项3', 'warning');
              return;
            }

            if (this.accidentData.formData.exts[extField.name].length == 0) {
              this.osg.toast(extField.nameDisp + '为必填项4', 'warning');
              return;
            }
          }
        }

        if (extField.type == 'phone') {
          if (
            !this.checkMobile(
              this.accidentData.formData[
                extField.preset == 1 ? extField.name : 'exts.' + extField.name
              ]
            )
          ) {
            this.osg.toast(extField.nameDisp + '格式错误', 'warning');
            return;
          }
        }
      }
      console.log(this.accidentData.formData);
      return true;
    },
    //保存出险质保
    doAccidentSave() {
      console.log(this.accidentData.formData);
      if (this.myValidate()) {
        // let imageList = this.accidentData.formData.exts
        //   ? this.accidentData.formData.exts.image
        //   : [];
        // this.$util.saveExtField(this.accidentExtFields, this.accidentData.formData);
        this.accidentData.formData.serviceAppointmentId = this.accidentData.row.sid; //工单id
        this.accidentData.formData.exts.warrantyId = this.accidentData.row._id; //质保id
        this.accidentData.formData.exts.serviceAppointmentNum = this.accidentData.row.serviceAppointmentNum; //服务工单编号
        this.accidentData.formData.exts.customerFlow = this.accidentData.row.docId; //客户流水号
        this.accidentData.formData.exts.startTime = this.accidentData.row.startTime; //保障生效时间
        this.accidentData.formData.exts.warrantyTime = this.accidentData.row.warrantyTime; //保障结束时间
        this.accidentData.formData.exts.certificateNo = this.accidentData.row.identity; //身份证号

        this.osg.ajax(
          'basic/workOrder/upsert.do',
          { data: JSON.stringify(this.accidentData.formData) },
          res => {
            this.doAccidentInit();
            this.osg.toast('操作成功！');
          },
          {
            fail: () => {
              // this.accidentData.formData.exts.image = imageList;
            }
          }
        );
      }
    },
    selectionChange(rows) {
      this.selectedList = rows;
    },
    batchExpurgate() {
      var data = this.selectedList;
      if (data.length > 0) {
        var warrantyIds = [];
        data.forEach(item => warrantyIds.push(item._id));
        warrantyIds = warrantyIds.join(',');
        this.osg.ajax('document/batchArchive.do', { warrantyIds: warrantyIds }, res => {
          if (res.success == false) {
            this.$message.error(res.message);
          }
          if (res.success == true) {
            this.$message.info('操作成功');
            this.getData();
          }
        });
      } else {
        this.$message.error('未选择质保数据');
      }
    },
    handleRowClick(row) {
      this.$router.push({
        path: `/Warranty/${row.extId}`,
        query: {
          warrantyId: row._id
        }
      });
      this.SetCachedViews({
        params: row.ownerName,
        action: `/Warranty/${row.extId}?warrantyId=${row._id}`
      });
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      this.viewReload();
    }
  }
};
</script>
<style scoped>
.accidentFormWarranty-wrapper >>> .el-icon-delete {
  display: none;
}
.accidentFormWarranty-wrapper >>> .el-icon-close-tip {
  display: none !important;
}
</style>
